import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { meioPagamento } from "./../NFCe.Dto";
import NFCeModalFinalizaCode from "./NFCe.Modal.Finaliza.Code";
import { NFCeModalFinalizarProps } from "./NFCe.Modal.Finalizar.Dto";
import { FloatInput } from "src/componentes";

export const NFCeModalFinalizarView = ({
  show,
  onHide,
  totalNFCe,
  dataMeioPagamento,
  onSelect,
  onCancel,
  onSubmit,
}: NFCeModalFinalizarProps) => {
  const {
    onSubmitMeioPagamento,
    errors,
    register,
    handleSubmit,
    exibirValor,
    selecionadoMeioPagamento,
    totalPago,
    totalTroco,
    handleClickMeioPagamento,
    onHideClick,
    podeFinalizar,
    onCancelClick,
    handleSubmitDestinatario,
    onSubmitDestinatario,
    registerDestinatario,
    errorsDestinatario,
  } = NFCeModalFinalizaCode(
    dataMeioPagamento,
    onSelect,
    onHide,
    onCancel,
    totalNFCe,
    onSubmit
  );

  return (
    <>
      <Modal show={show} centered>
        <Modal.Body>
          {!podeFinalizar() ? (
            <Form
              id="formPagamento"
              noValidate
              onSubmit={handleSubmit(onSubmitMeioPagamento)}
            >
              {!exibirValor ? (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th className="col-12">Forma pagamento</th>
                    </tr>
                  </thead>
                  <tbody>
                    {meioPagamento.map((item) => (
                      <tr
                        key={item.meioPagamento}
                        onClick={handleClickMeioPagamento(item)}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="col-12">{item.descricaoPagamento}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <>
                  <Row>
                    <Col xs={12} className="text-center">
                      <h1>{selecionadoMeioPagamento?.descricaoPagamento}</h1>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <FloatInput
                        label="Valor"
                        errorsMessage={errors.valorPagamento}
                        registerField={register("valorPagamento")}
                        inputMask="double"
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Form>
          ) : (
            <Form
              id="formDestinatario"
              noValidate
              onSubmit={handleSubmitDestinatario(onSubmitDestinatario)}
            >
              <Row>
                <Col xs={12}>
                  <FloatInput
                    label="CPF/CNPJ"
                    errorsMessage={errorsDestinatario.documento}
                    registerField={registerDestinatario("documento")}
                    inputMask="cnpj-cpf"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <FloatInput
                    label="Nome"
                    errorsMessage={errorsDestinatario.nome}
                    registerField={registerDestinatario("nome")}
                    inputMask="capitalizar"
                  />
                </Col>
              </Row>
            </Form>
          )}

          <Row>
            <Col>Total: {totalNFCe.toFixed(2).replace(".", ",")}</Col>
            <Col className="text-center">
              Pago: {totalPago().toFixed(2).replace(".", ",")}
            </Col>
            <Col className="text-end">
              Troco: {totalTroco().toFixed(2).replace(".", ",")}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {podeFinalizar() && (
            <Button
              variant="outline-danger"
              className="messagebox-btn-cancel"
              onClick={onCancelClick}
            >
              Cancelar
            </Button>
          )}
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onHideClick}
          >
            Voltar
          </Button>
          {exibirValor ? (
            <Button type="submit" form="formPagamento">
              Confirmar
            </Button>
          ) : podeFinalizar() ? (
            <Button type="submit" form="formDestinatario">
              Finalizar
            </Button>
          ) : (
            <></>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
